import { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import Translation from "../translation/translation.component";
import CrudTable from "../details-table/crud-table.component";
import { NotificationModal } from "../modal/notification-modal.component";
import DATEPICKER_OR from "./custom-date-picker.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../utils/constant.utils";
import { ConfirmationNotificationModal } from "../modal/confirmation-modal.component";
import { ACTION_TYPES, INTEGER_INVALID_CHARS, MAX_LENGTH, MODAL_CUSTOM_MESSAGE } from "../../../constants/external-constants";
import { InputField } from "./input-filter-component";
import { CustomDropdown } from "./custom-dropdown.component";
import Moment from 'moment';
import { bindActionCreators } from "@reduxjs/toolkit";
import { BillingAccountAction } from "../../../store/external/finance/billing-account/billing-account-details.reducer";
import { convertToFormatLocalDate, convertToTimeZoneDate, isInteger } from "../../../utils/helpers.utils";

class AddPurchaseOrder extends Component {
    constructor(props){
        super(props);
        this.state={
          showNotif:false,
          haveError:false,
          haveFieldError: false,
          modalMessage:'',
          poNumber:'',
          poValue:'',
          validFrom:null,
          validTo:null,
          activeDropdown: false,
          dataTable:[[]],
          showModal: false,    
          updatePlanComponentDetails: false,   
          fieldTypes:[
            {
                name:'PONumber',
                type:'text',
                required:true
              },{
                name:'POValue',
                type:'number',
                required:true
              },{
                name:'ValidDateFrom',
                type:'date',
                startDate: true,
                required:true
              },{
                name:'ValidDateTo',
                type:'date',
                required:true
              }
        ],
        financeAccountID:0,
        headerTable:[]
        }
    }

    componentDidMount() {
        const { financeId } = this.props;

        this.props.getAccountPurchaseOrder(financeId).then(() => {
            const { accountPurchaseOrder } = this.props.billingAccountDetails;
            const purchaseOrderHeaderData = accountPurchaseOrder?.dataTable[0]?.HeaderItem;
            const purchaseOrderDataItem = accountPurchaseOrder?.dataTable[0]?.dataItem;

            this.setState((prevState) => {
                const newState = {};

                if (purchaseOrderHeaderData) {
                    newState.headerTable = [...prevState.headerTable, purchaseOrderHeaderData[0]];
                }

                if (purchaseOrderDataItem) {
                    const updatedDataTable = [...prevState.dataTable];
                    updatedDataTable[0]?.push(purchaseOrderDataItem);
                    newState.dataTable = updatedDataTable[0];
                }

                return newState;
            });
        });
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    fetchDropdownValue = (value) => {
      alert("dropdown code here")
    };

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    }   
    
    toLocaleLanguage = (key) => {
          const { locale } = this.props;
          if (locale === null || locale === '' || locale === undefined)
              return translation[translation['defaultLocaleLanguage']][key];
  
          return translation[locale][key];
      }

    handleInputField = (e) =>{
        const { name ,value} = e.target
        if(name === "poValue") {
            if(!value) {
                this.setState({ [name]: "" });
                return
            }
        }
        this.setState({[name]: value})
    }

    handleResetField = () => {
        this.setState({
            poNumber:'',
            poValue:'',
            validFrom:null,
            validTo:null,
        })
    }

    handleResetModal = () => {
        this.setState({
            showNotif:false,
            haveError:false,
            haveFieldError:false,
            modalMessage:""
        })
    }

    handleAddData = () => {
        const { financeAccountID, poNumber, poValue, validFrom, validTo } = this.state;
        const { activeTimeZoneOffset } = this.props.adminSetting;

        if (this.handleValidateData()) {
            return;
        }

        let newItem = {
            Key: Math.floor(Math.random() * 1000),
            PONumber: poNumber,
            POValue: poValue,
            ValidDateFrom: validFrom, //convertToFormatLocalDate(validFrom, activeDateFormat.Name),
            ValidDateTo: validTo, //convertToFormatLocalDate(validTo, activeDateFormat.Name),
            FinanceAccountID: financeAccountID,
            CreatedByUserID: sessionStorage.getItem('UserRoleID'),
            CreatedDate: `${Moment(new Date()).format('L')} ${Moment(new Date()).format('LT')}`,
            LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`
        };

        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];
            const index = updatedDataTable[0].findIndex(x => new Date(x.ValidDateFrom) > validFrom);

            if (index === -1) {
                updatedDataTable[0].push(newItem);
            } else {
                updatedDataTable[0].splice(index, 0, newItem);
            }

            return { dataTable: updatedDataTable };
        }, () => {
            this.props.handleFetchPurchaseOrder(this.state.dataTable);
        });

        this.handleResetField();
        this.handleResetModal();
    };


     handleClickAddBtn = ()=> {
            this.setState({
                showModal:true,
            })
        }
    
    handleConfirmationModal = (buttonType) => {
              
                if (buttonType === CONFIRMATION_VALUE.Ok) {
                        this.handleAddData();
                    this.setState(prev => ({
                        showModal: !prev.showModal,
                        enableEdit: false,
                        updateCostAllocationDetails: false,
                        isExist: false,
                        isGreater: false
                    }))
        
                } else {
                    this.setState({
                        showModal: false
                    });
                }
            }

    updateData = (key, newData) => {
        const { activeTimeZoneOffset } = this.props.adminSetting;
        const currentUser = `${sessionStorage.FirstName} ${sessionStorage.LastName}`;

        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];

            if (Array.isArray(updatedDataTable[0])) {
                const index = updatedDataTable[0].findIndex((item) => item.Key === key);

                if (index !== -1) {
                    updatedDataTable[0][index] = {
                        ...updatedDataTable[0][index],
                        ...newData[index],
                        LastModified: `${currentUser} on ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(), activeTimeZoneOffset?.UtcOffset)).format('LT')}`,
                    };
                }
                updatedDataTable[0].sort((a, b) => new Date(a.ValidDateFrom) - new Date(b.ValidDateFrom));
                return { dataTable: updatedDataTable };
            }
            return null;
        }, () => {
            this.props.handleFetchPurchaseOrder(this.state.dataTable);
        });
    };


    handleDeleteData = (key) => {
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];

            if (Array.isArray(updatedDataTable[0])) {
                updatedDataTable[0] = updatedDataTable[0].filter((x) => x.Key !== key);
            }
            return { dataTable: updatedDataTable };
        }, () => {
            this.props.handleFetchPurchaseOrder(this.state.dataTable);
        });
    };

    handleValidDateFrom = (date) => {
        const { validTo } = this.state;       
        if(new Date(validTo) < new Date(date)) {
            this.setState({validTo:null})
        }
        this.setState({validFrom:date})
    }

    handleBlur = (e) => {
        const { name,value } = e.target;
        if (name === "poValue")
        {
            this.setState({[name]:parseFloat(value).toFixed(2)})
        }
    };

    handleValidateData = (buttonType)=>{
        const { dataTable, poNumber } = this.state;
        if (dataTable[0]?.length !== 0) {
            const alreadyExist = dataTable[0]?.some(
                (item) =>
                    item.PONumber === poNumber
            )

            if (alreadyExist) {
                this.setState({
                    showNotif: true,
                    haveFieldError: true,
                    modalMessage: "po_number_already_exists"
                });
                return true
            }
            else {
                this.handleClickAddBtn();
            }
        }
        else {
            this.handleClickAddBtn();
        }
    }

    handleTableValidation=(key, updatedData)=>{
        const setCombination = new Set();
        const duplicates=[];

        (updatedData || []).forEach((item)=>{
            const combination=`${item.PONumber}`;
            if(setCombination.has(combination)) {
                duplicates.push(item);
            } else {
                setCombination.add(combination)
            }
        })

        if(duplicates.length > 0) {
            this.setState({tableHasError:true})
            this.setState({
                showNotif:true,
                haveError:true,
                modalMessage:"po_number_already_exists"
            })
            return ["PONumber"]
        }
    }

    handleCancel = () => {
        this.setState({
            poNumber: '',
            poValue: '',
            validFrom: null,
            validTo: null,
            activeDropdown: false,
            haveFieldError: false
        })
    }

    handleOnBeforeInput = (e, type) =>{
        if (type === "number") {
            const currentValue = e.target.value;
            if ( INTEGER_INVALID_CHARS.includes(e.data) ||
                (e.data === '.' && currentValue.includes('.'))
            ) {
                e.preventDefault();
            }
        }
    }

    render(){
        const { poNumber, poValue, validFrom, validTo, showModal, updatePlanComponentDetails, dataTable, headerTable, fieldTypes,
                showNotif, haveError, modalMessage, haveFieldError, activeDropdown
        } = this.state;

        const disabledBtn = (!poNumber || !poValue || !validFrom || !validTo || poValue === "NaN");

        return(
            <div>
                <CustomDropdown
                    label={<Translation translationKey={"add_purchase_order"} />}
                    activeDropdown={activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                  <div className="add-sim-container">

                        <div className="add-purchase__container">
                            <div className="add-purchase__form-wrapper">                          
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('po_number').toUpperCase()}`}
                                    inputValue={poNumber}
                                    name="poNumber"
                                    onChange={this.handleInputField}
                                    disabled={false}
                                    hasError={haveFieldError}
                                    requiredField={true}
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                />
                                <InputField
                                    className="form-control"
                                    type="number"
                                    isDecimal={true}
                                    label={`${this.toLocaleLanguage('po_value').toUpperCase()}`}
                                    name="poValue"
                                    inputValue={poValue}
                                    onChange={this.handleInputField}
                                    onBlur={this.handleBlur}
                                    disabled={false}
                                    requiredField={true}
                                    maxLength={MAX_LENGTH.inputText}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    onBeforeInput={(e) => this.handleOnBeforeInput(e, "number")}
                                />
                                <DATEPICKER_OR 
                                    dateOnly={true} 
                                    label={`${this.toLocaleLanguage('valid_from').toUpperCase()}`} 
                                    placeholder={`${this.toLocaleLanguage('select_date')}`} 
                                    startDate={validFrom} 
                                    selectedDate={(date)=>{this.handleValidDateFrom(date)}} 
                                    isDisable={false}
                                    requiredField={true}
                                />
                                <DATEPICKER_OR 
                                    dateOnly={true} 
                                    minDate={validFrom}
                                    label={`${this.toLocaleLanguage('valid_to').toUpperCase()}`} 
                                    placeholder={`${this.toLocaleLanguage('select_date')}`} 
                                    startDate={validTo} 
                                    selectedDate={(date) => this.setState({validTo:date})} 
                                    isDisable={false}
                                    requiredField={true}
                                />
                            </div>
                            <div className="add-button-container custom-add-button">

                            <div className="btn-tooltiptext">
                                <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                <span className="tooltip-text">{<Translation translationKey="cancel_adding_purchase_order" />}</span>
                            </div>
                           
                            <ConfirmationNotificationModal
                                show={showModal}
                                message={updatePlanComponentDetails ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                                title={updatePlanComponentDetails ? 'Update' : 'Add'}
                                handleModal={this.handleConfirmationModal}
                                customClass={'comment-notification-modal modal-text-bold'}
                            />

                                <div className={'btn-tooltiptext'}>
                                    <Button                                  
                                        onClick={this.handleValidateData}
                                        variant="primary"
                                        className="btn-add"
                                        disabled={this.props.isReadOnly || this.props.isReadAndExtractOnly ?  true: disabledBtn}
                                    >
                                        {`${ACTION_TYPES.Add}`}

                                    </Button>
                                    <span className="tooltip-text"><Translation translationKey="add_purchase_order_details" /></span>
                                </div>
                            </div>
                        </div>
                       
                        <div className="details-table-container ">
                            <CrudTable
                                dataTable={dataTable[0]}
                                headerTable={headerTable}
                                fieldType={fieldTypes}
                                updateData={this.updateData}
                                handleDeleteData={this.handleDeleteData}
                                fetchDropdownValue={this.fetchDropdownValue}
                                customValidation={this.handleTableValidation}
                                haveDeleteAndEditBtn={(this.props.isReadAndWrite ? true : false)}
                                hasScroll={false}                            
                            />
                        </div>
                    
                  </div>  

                </CustomDropdown>               
                 <NotificationModal
                      show={showNotif}
                      title={(haveError || haveFieldError) ? 'Error' : 'Success'}
                      message={<Translation translationKey={modalMessage} />}
                      handleModal={this.handleCloseNotif}
                      customClass={'comment-notification-modal notification-footer modal-text-bold'}
                  />                                 
            </div>
        )
    }
}


export default connect(
    state=> {
        const { translation,
                billingAccountDetails,
                adminSetting
        } = state;
       
        return {
            billingAccountDetails,
            adminSetting,
           ...translation
        };
    },
    dispatch=>({
        ...bindActionCreators(
            Object.assign({},
                BillingAccountAction
            ),
            dispatch
        )
    })
)(AddPurchaseOrder);